import { render, staticRenderFns } from "./MtModalFull.vue?vue&type=template&id=68059296&"
import script from "./MtModalFull.vue?vue&type=script&lang=js&"
export * from "./MtModalFull.vue?vue&type=script&lang=js&"
import style0 from "./MtModalFull.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports